// FL => Form Label
export const FL_ID = "ID";
export const FL_UID = "Firebase Id";
export const FL_UDN = "Unidad de negocio";
export const FL_ROUT = "Ruta";
export const FL_CODE = "Código";
export const FL_TYPE = "Tipo";
export const FL_ICON = "Icono";
export const FL_INVERTED_ICON = "Icono invertido";
export const FL_NAME = "Nombre";
export const FL_NUMBER = "Número";
export const FL_PROJECT = "Proyecto";
export const FL_DATA_BASE = "Base de datos";
export const FL_MAIN_DATA_BASE = "Base de datos principal";
export const FL_SHORT_NAME = "Nombre Corto";
export const FL_LONG_NAME = "Nombre Largo";
export const FL_ORDER = "Orden de presentación";
export const FL_ACTIVITY = "Actividad";
export const FL_STATUS = "Activo";
export const FL_TAX_INCLUDED = "Incluye impuestos";
export const FL_INTEREST = "Punto de interes";
export const FL_ADITIONAL_COST = "Costo adicional";
export const FL_ADITIONAL_INFO = "Información adicional";
export const FL_RESERVATION_NEEDED = "Requiere reservacion";
export const FL_IMAGE = "Imagen";
export const FL_PRESENTATION = "Presentación";
export const FL_SCHEDULE = "Horarios de apertura";
export const FL_INCLUDE = "Incluye";
export const FL_WARNING = "Advertencias";
export const FL_RESTAURANT = "Restaurante / Bar";
export const FL_SPA = "Spa";
export const FL_INCLUDE_INFANTS = "Incluir precio de menores";
export const FL_INCLUDE_FOOD = "Incluye comida";
export const FL_START_DATE = "Valido desde";
export const FL_END_DATE = "Valido hasta";
export const FL_CONCEPT = "Concepto";
export const FL_OPEN_FOR = "Abierto para";
export const FL_CAMPAIGN = "Campaña";
export const FL_CATEGORY = "Categoría";
export const FL_SUB_CATEGORY = "Categoría secundaria";
export const FL_FILE = "Archivo";
export const FL_MENU = "Menu";
export const FL_MENU_COLOR = "Color de fondo Menu";
export const FL_MENU_FORE_COLOR = "Color de letra Menu";
export const FL_MENU_BACKGROUND = "Fondo para Menu";
export const FL_MENU_LOGO = "Logo para Menu";
export const FL_MENU_SIGNATURE = "Firma para Menu";
export const FL_ATTRIBS = "Atributos";
export const FL_BADWORD = "Palabra";
export const FL_DATE = "Fecha";

export const FL_VIDEO_URL = "Url de video";

export const FL_NEXT_VIEW = "Código de vista siguiente";
export const FL_TOP_PREFERENCE = "Es promoción top?";
export const FL_USE_PAX_TO_PRICES = "Usar PaxMin para precios?";
export const FL_COUPON = "Cupon";
export const FL_CAT_PROM = "Categoría de promoción";
export const FL_CAT_PROD = "Categoría de producto";
export const FL_FATHER_CATEGORY = 'Categoría Padre'
export const FL_GENERAL_CATEGORY = 'Categoría de Uso General'
export const FL_TYPE_VIEW = 'Tipo de recuadro'
export const FL_TYPE_AMENITY = 'Tipo de amenidad'
export const FL_TIPO_PROD = "Tipo de producto";
export const FL_DESTINATION = "Destino";
export const FL_TYPE_DESTINATION_ACTIVITY = "Tipo de actividad";
export const FL_SIVEX_ID = "Id Sivex";
export const FL_SIVEX_CODE = "Código Sivex";
export const FL_COMPONENT_ID = "Id de componente";
export const FL_LANDING_CODE = "Código langing";
export const FL_PARAM_C = "Parámetro C";
export const FL_PARAM_T = "Parámetro T";
export const FL_PARAM_P = "Parámetro P";
export const FL_PARAM_D = "Parámetro D";
export const FL_IS_BASE_PRODUCT = "Es producto base?";
export const FL_LEVEL = "Nivel";
export const FL_POINT_A = "Punto A";
export const FL_POINT_B = "Punto B";
export const FL_WEIGHT = "Magnitud / Distancia";

export const FL_INDICATIONS = "Indicaciones";
export const FL_IVERTED_INDICATIONS = "Indicaciones invertidas";
export const FL_AMENITY = "Amenidad";
export const FL_BRAND = "Marca";
export const FL_VALUE = 'Valor';
export const FL_PAX_MAX = 'Maximo de pax';
export const FL_PAX_MIN = 'Minimo de pax';
export const FL_VERSION_ANDROID = 'Versión ANDROID';
export const FL_VERSION_IOS = 'Versión IOS';
export const FL_PLACE = 'Lugar'
export const FL_TITLE = "Título";
export const FL_DESCRIPTION = "Descripción";
export const FL_SHORT_DESCRIPTION = "Descripción (255 Caracteres)";
export const FL_LONG_DESCRIPTION = "Descripción (8mil Caracteres)";
export const FL_TERMS_AND_CONDS = "Términos y Condiciones";
export const FL_INFO_WINDOW = "Ventana informativa";
export const FL_SHOW_IN_HOME = "Mostrar en Home";
export const FL_PAX = 'Pax'
export const FL_EXTRA = 'Extra'
export const FL_ALLOWED_TO_BUY = 'Permitido comprar'
export const FL_ACTIONS = 'Acciones'
export const FL_COLOR = 'Color'
export const FL_RATIO = 'Radio'
export const FL_RELATED_FOOD = 'Alimentos relacionados'
export const FL_PRIMARY_COLOR = 'Color Primario'
export const FL_SECONDARY_COLOR = 'Color Secundario'
export const FL_NOTE = 'Nota'
export const FL_RECOMENDATION = 'Recomendaciones'
export const FL_CAPACITY = 'Capacidad'
export const FL_DURATION = 'Duración'
export const FL_HORARIO = 'Horario'
export const FL_HORARIO_DURATION = 'Hora de inicio - Duración'
export const FL_PRODUCT = 'Producto'
export const FL_GIFT = 'Gift'
export const FL_TERM = 'Termino'
export const FL_GROUP = 'Grupo'
export const FL_MINIMUN_STAY_REQUIRED ='Estancia mínima requerida'
export const FL_ONLY_REGISTERED ='Solo registrados en la app'
export const FL_BODY = "Cuerpo";
export const FL_CLOUD_MESSAGE_ID = "Cloud Message ID";
export const FL_DUE_DATE = "Fecha de Vencimiento";
export const FL_AIRPORT = "Aeropuerto";
export const FL_START_HOUR = "Hora de inicio";
export const FL_END_HOUR = "Hora de fin";
export const FL_HOST = "Anfitrión";
export const FL_FORUM = "Foro";
export const FL_DOES_IT_REPEAT = "¿Se repite?";
export const FL_HIGHLIGHT = "Highlight";
export const FL_AUDIENCE_TYPE = "Tipo de audiencia";

export const FL_CLASS_NAME = "Nombre de clase"